import { mapGetters, mapActions } from "vuex"
const jwt = require("jsonwebtoken");


const globalMixin =  {
  computed: {
    ...mapGetters({
      user : "site/getUser",
      me : "site/getUser",
      getDataUser: "site/getDataUser",
      getToken: "site/getToken",
      getRefrechToken: "site/getRefrechToken",
      getExpiredToken: "site/getExpiredToken",
      getProfilesUser: "site/getProfilesUser",
      getRolesUser: "site/getRolesUser",
      getIdUser: "site/getIdUser",
      getProfilesUserType: "site/getProfilesUserType",
      getRolesUserRoute: "site/getRolesUserRoute",
      getAuth:"site/getAuth",
      getRegisterTab: "site/getRegisterTab",
      getApiDetailsTab: "site/getApiDetailsTab",
      getNoUseCookies: 'site/getNoUseCookies',
      getIdUserWhoAccepted: 'site/getIdUserWhoAccepted',
      getkeysSessions:'site/getkeysSessions',
    }),
    userToken(){
        // return this.getItemNoCoockie('token') ? this.getItemNoCoockie('token') :this.getToken;
        return this.getToken
    },
    tokenType(){
      // return this.getItemNoCoockie('token_type') ? this.getItemNoCoockie('token_type'):'Bearer'
      return 'Bearer'
    },
    isExpiredToken(){
      // return this.getItemNoCoockie('expires_in') ? this.getItemNoCoockie('expires_in'):this.getExpiredToken
      return this.getExpiredToken
    },
    browserNotaccepted (){
      return this.needAcceptCookies()
    }

  },
  methods: {
    ...mapActions({
      setlogOut: "site/setlogOut",
      setUser: "site/setUser",
      changeUserData: "site/changeUserData",
      setAuth: "site/setAuth",
      setLastUpdatedDataOrg: "organization/setLastUpdatedDataOrg",
      setOrganization: "organization/setOrg",
      setRegisterTab: "site/setRegisterTab",
      setApiDetailsTab: "site/setApiDetailsTab",
      setNoUseCookies:"site/setNoUseCookies",
      setIdUserWhoAccepted:"site/setIdUserWhoAccepted",
    }),
    async requestEds(method, route, body, type, pages, token) {
      let tokenNoHeader =  token ? token: this.getToken
      if (this.userToken &&  !this.tokenValid()){
        return
      }
      let headers = {}
      if (type && type == 'file') {
        headers = {'Content-Type' :'multipart/form-data'}
      }
      headers.Authorization = `${this.tokenType} ${tokenNoHeader}`

      let urlRoute = route
      if (type && type == 'page') {
          let newPages = {
            size : pages && pages.size? pages.size : 10,
            page : pages && pages.page? pages.page : 1
          }
        urlRoute = `${route}&size=${newPages.size}&page=${newPages.page}`
      }
      return await this.$axios({
        method,
        url: urlRoute,
        data: body,
        headers :{...headers}
        
      })
      .then((res) => {
        return res
      })
      .catch((error) => {
        if (error.response) {
          this.errorResponse(error.response)
          if ( error.response &&  error.response.data && error.response.data.message){
            throw error.response.data
          }

          throw error.response
        }
        throw error
      })
    },
    saveInCookies(name, data, method) {
      method = !method? '':`${method}/`
      this.$cookiz.set(`${method}${name}`, jwt.sign(data,process.env.COOCKIES_SECRET_KEY) , {path: '/',
      maxAge: 60 * 60 * 24 * 7} )
    },
    getItemNoCoockie(name) {

      return this.$cookiz.get(name) ?
        jwt.verify(this.$cookiz.get(name),process.env.COOCKIES_SECRET_KEY)?
          jwt.verify(this.$cookiz.get(name),process.env.COOCKIES_SECRET_KEY):
            this.$cookiz.get(name) : null
    },
    needAcceptCookies(){
      const lastVersionCookeis = this.getItemNoCoockie('lastVersionCookeis')
      //const versionCookeis = this.getItemNoCoockie('cookiesPolicy')
      console.log('versionCookeis',lastVersionCookeis);
      return  lastVersionCookeis != null ? false : true
      //return  lastVersionCookeis != null && versionCookeis != lastVersionCookeis ?  true : versionCookeis === null?  true : false
    },
    async axios(method, route, token, body) {
      let tokenNoHeader =  token ? token: this.userToken
      return await this.$axios({
        method,
        url: route,
        data: body,
        headers : {
          'Authorization':  tokenNoHeader? `Bearer ${tokenNoHeader}` : ''
        }

      })
      .then((res) => {
        return res
      })
      .catch((error) => {
        this.errorResponse(error)
        throw error
      })
    },
    errorResponse(error){
      if (error.response && error.response.status === 401) {
        sessionStorage.clear();
        window.location = process.env.VUE_APP_URL;
      }
      if(error && error.status === 401){
        sessionStorage.clear();
        this.logoutInvalidUser()
      }
    },
    haveRole(route){
      if(this.getRolesUser.length > 0){
        return this.getRolesUser.includes(route)
      }
      return false;
    },
    typeProfile(type){
      let isType = false
      if(this.getProfilesUser.length > 0){
        for (let index = 0; index < this.getProfilesUser.length; index++) {
          const element = this.getProfilesUser[index];
          if(element.includes(type)){
            isType = true
          }
        }
      }
      return isType;
    },
    isAdmin(){
      return this.typeProfile('admin');
    },
    isConsumer(){
      return this.typeProfile('consumer');
    },
    isManager(){
      return this.typeProfile('manager');
    },
    tokenValid(){
      // if (this.getExpiredToken < new Date()/1000) {
      //   return this.refrechToken()
      // }
      if (this.isExpiredToken < new Date()/1000) {
        this.logout()
        return false
      }
      return true;

    },
    hasLogin(data){
      if(!this.browserNotaccepted){
        for (let [key, value] of Object.entries(data)) {
              let newValue = key == 'access_token' ? jwt.decode(value) : value
              this.saveInCookies(key,newValue)
          }
      }
    },
    logout(redirect='/home'){
      // TODO - Include request backend logout
      this.requestEds('POST', 'auth/logout')
      const statusAcceptCookies = this.getNoUseCookies
      const statusIdUsuerWhoAcceptCookies = this.getIdUserWhoAccepted
      this.setlogOut()
      localStorage.clear()
      this.getkeysSessions.map((itm)=>{

        this.$cookiz.remove(itm)
      })

      this.setNoUseCookies(statusAcceptCookies)
      if(!statusAcceptCookies){
        this.setIdUserWhoAccepted(statusIdUsuerWhoAcceptCookies)
      }

      this.$router.push(redirect);
    },
    logoutInvalidUser(redirect='/home'){
      const statusAcceptCookies = this.getNoUseCookies
      const statusIdUsuerWhoAcceptCookies = this.getIdUserWhoAccepted
      this.setlogOut()
      localStorage.clear()
      this.getkeysSessions.map((itm)=>{

        this.$cookiz.remove(itm)
      })

      this.setNoUseCookies(statusAcceptCookies)
      if(!statusAcceptCookies){
        this.setIdUserWhoAccepted(statusIdUsuerWhoAcceptCookies)
      }
      this.$router.push(redirect);
    },
  },

}

export default globalMixin;
